import "../style/SectionAbout.css";
import aboutImage from "../assets/images/about-image.JPG";
import { useNavigate } from "react-router-dom";
import React,{useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';

const SectionAbout = () => {
  useEffect(() => {
    AOS.init();
  }, [])

  const navigate = useNavigate();

  return (
    <section className="about-section">
      <div className="about-container">
        <div className="about-image" data-aos="fade-right" data-aos-duration="1000">
          <img src={aboutImage} alt="Steel Detailing" />
        </div>
        <div className="about-content" data-aos="fade-left" data-aos-duration="1000">
          <h2>
            ABOUT <span className="highlight">SteelX Detailing and Engineering Services</span>
          </h2>
          <h3>
            We have established ourselves a trusted leader in market as a Steel
            Detailer.
          </h3>
          <p>
            Steel X is steel detailing company started into providing STEEL
            detailing services. Steel X prides itself in its team of highly
            trained individuals with years of detailing experience. Each team
            members have developed to the skills that allow them.We are
            providing services to the Steel Fabricators, Contractors &
            manufactures. For Quality assurance, we are associate members with
            AISC, ACI AND CRSI We provide accurate and high quality drawings for
            structural steel fabricators. Our detailing well trained staff is
            proficient of doing all type of work complies with AISC, NISC, CISC,
            ASTM BS, IS CODES, requirement of as well as IBC, OHSA.
          </p>
          <div>
            <button
              className="about-button"
              onClick={() => navigate("/aboutus")}
            >
              Read more →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionAbout;
